import { SubscriptionTierEnum } from '../common/enums';
import { AuthResponse } from '../preContest/store/types';
import { APIState } from '../utils/api/reducer';
import useCookie from 'react-use-cookie';
import { APIConstants } from './api/constants';
import { getPersistentUserId } from '../../utils/persistentUserId';
import { useAuth0 } from '@auth0/auth0-react';


export const userSubscribed = (authenticated: APIState<AuthResponse>, selectedSite: {site: string}, selectedSport: {sport: string}) => {
  if (!authenticated) {
    return null;
  }

  if (isFreeCoreAccess(selectedSite, selectedSport)) {
    return true;
  }

  if (authenticated?.status === APIConstants.SUCCEEDED && (
    authenticated?.data?.authTier === SubscriptionTierEnum[SubscriptionTierEnum.CORE] ||
    authenticated?.data?.authTier === SubscriptionTierEnum[SubscriptionTierEnum.SIMS_BASIC] ||
    authenticated?.data?.authTier === SubscriptionTierEnum[SubscriptionTierEnum.SIMS_MAX] ||
    authenticated?.data?.authTier === SubscriptionTierEnum[SubscriptionTierEnum.MVP]
  )) {
    return true;
  } else {
    return false;
  }
};

// Check if user has MVP tier access (highest tier)
export const isMvpTier = (authTier?: string): boolean => {
  return authTier === SubscriptionTierEnum[SubscriptionTierEnum.MVP];
};

// Check if user has premium access (SIMS_MAX or MVP)
export const hasPremiumAccess = (authTier?: string): boolean => {
  return authTier === SubscriptionTierEnum[SubscriptionTierEnum.SIMS_MAX] ||
    authTier === SubscriptionTierEnum[SubscriptionTierEnum.MVP];
};

// Check if user has MVP-level access
export const hasMvpAccess = (authTier?: string): boolean => {
  return isMvpTier(authTier);
};
  
export const useUserId = () => {
  const [userToken] = useCookie('user', '{}');
  const { user, isAuthenticated } = useAuth0();

  // Try cookie first
  try {
    const cookieId = JSON.parse(userToken || '{}')?.id;
    if (cookieId) return cookieId;
  } catch (e) {
    // Invalid JSON in cookie
  }

  // Fallback to Auth0 user email (base64 encoded to match cookie format)
  if (isAuthenticated && user?.email) {
    return btoa(user.email.toLowerCase().trim());
  }

  return undefined;
}

export const useUserToken = () => {
  const [userToken] = useCookie('user', '{}');
  try {
    return JSON.parse(userToken || '{}')?.token;
  } catch (e) {
    return undefined;
  }
}

export const isFreeCoreAccess = (selectedSite: {site: string}, selectedSport: {sport: string}) => {
  return false;
}

/**
 * Returns a persistent user ID (base64 encoded email) that survives across sessions and apps.
 * Returns the stored persistent ID from localStorage, or null if not logged in yet.
 */
export const usePersistentUserId = () => {
  return getPersistentUserId();
}